<template>
	<div class="tab_box2">
		<div class="tab_tit">
			<p class="tab_tit_p1">{{titobj.title1}}</p>
			<p class="tab_tit_p2">{{titobj.title2}}</p>
		</div>
		<ul>
			<li v-for="(item,index) in tablist" :key="index" @click="tabChange(index,item)">
				<div class="flex3" :class="actIndex==index?'tab_act2':''">
					<span>+</span>
					<span>{{item.title}}</span>
				</div>
				<p class="line2"></p>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		titobj: {
			type: Object,
			required: true,
		},
		tablist: {
			type: Array,
			required: true,
		},
		actIndex: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {}
	},
	methods: {
		tabChange(index, item) {
			this.$emit('tab-change', index);
			if (item.name) {
				this.$router.push(item.name);
			}
		}
	}
}
</script>

<style lang="scss">
.tab_act2 {
	background-color: #9e0507 !important;
}
.tab_box2 {
	width: 294px;
	min-height: 500px;
	background-image: url("../images/navbg2.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
	box-sizing: border-box;
	padding-top: 25px;
    padding-bottom: 20px;
	.tab_tit {
		border-bottom: 1px solid #d48483;
		padding-bottom: 10px;
		margin: 0 18px;
		.tab_tit_p1 {
			color: #fff;
			font-size: 26px;
			font-weight: bold;
		}
		.tab_tit_p2 {
			color: #fff;
			font-size: 16px;
			margin-top: 10px;
		}
	}
	ul {
		li {
			padding-top: 12px;
			cursor: pointer;
			div {
				height: 70px;
				padding: 0 18px;
				span {
					&:nth-child(1) {
						color: #fde196;
						font-size: 18px;
						font-weight: bold;
					}
					&:nth-child(2) {
						font-size: 20px;
						color: #fff;
						margin-left: 10px;
					}
				}
			}
			.line2 {
				height: 1px;
				margin: 0 18px;
				border-bottom: 1px dashed #d48483;
			}
		}
	}
}
@media screen and (max-width: 1600px) {
	.tab_box2 {
		width: 280px;
		height: 518px;
		background-image: url("../images/navbg2.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		box-sizing: border-box;
		padding-top: 25px;
		.tab_tit {
			border-bottom: 1px solid #d48483;
			padding-bottom: 10px;
			margin: 0 18px;
			.tab_tit_p1 {
				color: #fff;
				font-size: 26px;
				font-weight: bold;
			}
			.tab_tit_p2 {
				color: #fff;
				font-size: 16px;
				margin-top: 10px;
			}
		}
		ul {
			li {
				padding-top: 12px;
				cursor: pointer;
				div {
					height: 70px;
					padding: 0 18px;
					span {
						&:nth-child(1) {
							color: #fde196;
							font-size: 18px;
							font-weight: bold;
						}
						&:nth-child(2) {
							font-size: 20px;
							color: #fff;
							margin-left: 10px;
						}
					}
				}
				.line2 {
					height: 1px;
					margin: 0 18px;
					border-bottom: 1px dashed #d48483;
				}
			}
		}
	}
}
</style>